import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TreasuryApiResponse } from "../model/bank-account.model";
import { StaffSurplusRefundRequest, StaffSurplusRefundResponse, StaffSurplusRefundReviewRequest } from "../model/surplus-refund.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffSurplusRefundsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.url = `${basePath.replace(/\/$/, "")}/api/v1/surplus-refunds`;
  }

  create(request: StaffSurplusRefundRequest): Observable<TreasuryApiResponse<StaffSurplusRefundResponse>> {
    return this.http.post<TreasuryApiResponse<StaffSurplusRefundResponse>>(this.url, request);
  }

  listByExpenseReport(idExpenseReport: number): Observable<TreasuryApiResponse<StaffSurplusRefundResponse[]>> {
    return this.http.get<TreasuryApiResponse<StaffSurplusRefundResponse[]>>(this.url, {
      params: new HttpParams().set("idExpenseReport", idExpenseReport),
    });
  }

  get(id: number): Observable<TreasuryApiResponse<StaffSurplusRefundResponse>> {
    return this.http.get<TreasuryApiResponse<StaffSurplusRefundResponse>>(`${this.url}/${id}`);
  }

  review(id: number, request: StaffSurplusRefundReviewRequest): Observable<TreasuryApiResponse<StaffSurplusRefundResponse>> {
    return this.http.patch<TreasuryApiResponse<StaffSurplusRefundResponse>>(`${this.url}/${id}/review`, request);
  }
}
